<template>
  <div class=" pb-5">
    <vs-input
      v-validate="'required|alpha_spaces|min:3'"
      data-vv-validate-on="blur"
      label-placeholder="Full Name"
      name="username"
      placeholder="Full Name"
      v-model="username"
      class="w-full" />
    <span class="text-danger text-sm">{{ errors.first('username') }}</span>
    <vx-input-group class="mb-6 mt-6">
      <template slot="prepend">
        <div class="prepend-text bg-primary">
          <span>+91</span>
        </div>
      </template>

      <vs-input v-model="ContactNo" placeholder="Contact Number" v-validate="'required|length:10'" />
    </vx-input-group>
    <vs-input
      v-validate="'required|email'"
      data-vv-validate-on="blur"
      name="email"
      type="email"
      label-placeholder="Email"
      placeholder="Email"
      v-model="email"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

    <vs-input
      ref="password"
      type="password"
      data-vv-validate-on="blur"
      v-validate="'required|min:6'"
      name="password"
      label-placeholder="Password"
      placeholder="Password"
      v-model="password"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

    <vs-input
      type="password"
      v-validate="'min:6|confirmed:password'"
      data-vv-validate-on="blur"
      data-vv-as="password"
      name="confirm_password"
      label-placeholder="Confirm Password"
      placeholder="Confirm Password"
      v-model="confirm_password"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

    <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6">I accept the terms & conditions.</vs-checkbox>

   
    <vs-button  type="border" to="/pages/login" class="mt-6">Login</vs-button>
    <vs-button class="float-right mt-6" @click="registerUser" :disabled="!validateForm">Register</vs-button>
  </div>
</template>

<script>
import * as firebase from 'firebase/app'
//import NavbarDefault from '../components/vuesax/navbar/NavbarDefault'

//import TheFooter from '../../layouts/components/TheFooter';
import 'firebase/auth';
import 'firebase/firestore';

export default {
     components: {
          //NavbarDefault,
          //TheFooter
    },
    data() {
        return {
            username: '',
            email: '',
            password: '',
            confirm_password: '',
            c_code:'',
            isTermsConditionAccepted: true,
            code:[ ],
            college_code:"",
            stud:[],
            student_code:"",
            value:"",
            StudentCode:'',
            CollegeCode:'',
            ContactNo:''
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any()  && this.username != '' && this.email != '' && this.password != '' && this.confirm_password != '' && this.isTermsConditionAccepted === true;
        },
        
    },
    methods: {
        checkLogin() {
          // If user is already logged in notify
          if(this.$store.state.auth.isUserLoggedIn()) {

            // Close animation if passed as payload
            // this.$vs.loading.close()

            this.$vs.notify({
              title: 'Login Attempt',
              text: 'You are already logged in!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }
          return true
        },
        registerUser() {
            // If form is not validated or user is already login return
            if (!this.validateForm || !this.checkLogin()) return
            this.$validator.validateAll().then(result => {
                    if (result) {
                    const payload = {
                      userDetails: {
                        displayName: this.username,
                        email: this.email,
                        password: this.password,
                        confirmPassword: this.confirm_password
                      },
                      notify: this.$vs.notify,
                      updateUsername: true
                    }
            // create user using firebase
            firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
                .then(() => {
                    const user= firebase.auth().currentUser
                    
                        firebase.firestore().collection('AdminAccounts').doc(user.uid).set({
                       email: this.email,
                            timestamp : firebase.firestore.FieldValue.serverTimestamp(),
                            role: 'admin',
                            username:this.username 
                      },{merge: true}).then(() =>{
                          //console.log(this.$acl.get[0])
                        this.$store.dispatch('auth/login', payload)
                        //this.$router.push('/pages/login')
                        }).catch(err => {    
                            console.log(err.message)
                        })
                    this.$vs.notify({
                        title: 'Account Created',
                        text: 'You are successfully registered!',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                    });
                    
                   
                }, (error) => {
                    this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
                    }
                     else {
                        this.$vs.notify({color:'danger',title:'Oops!',text:'Please fill in all the fields correctly !', time:4000})
                        
                    }
            })
        }
    },
     
}
</script>
